import moment from "moment";
import { POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function createVehicle(obj) {
  try {
    let response = { error: true };
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/vehiculo/create-vehicle",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
      response.value = body;
    }
    return response;
  } catch (err) {
    console.log("createVehicle err");
    console.log(err);
    return { error: true };
  }
}

export async function obtenerListaVehiculos(obj, combo = false) {
  try {
    let response = [];
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/vehiculo/obtener-lista-vehiculos",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      if (combo === false) {
        response = body;
        for (let i = 0; i < response.length; i++) {
          response[i].fechaProceso = moment(response[i].fechaProces).format(
            "DD/MM/YYYY HH:mm",
          );
        }
      }
      if (combo === true) {
        response = body.map((item) => {
          return {
            value: item.id,
            label: item.nombre,
          };
        });
      }
    }
    return response;
  } catch (err) {
    console.log("obtenerInfoVehiculo err");
    console.log(err);
    return [];
  }
}

export async function obtenerInfoVehiculo(obj) {
  try {
    let response = { error: true };
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/vehiculo/obtener-info-vehiculo-sin-combustible",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
      response.value = body;
    }
    return response;
  } catch (err) {
    console.log("obtenerInfoVehiculo err");
    console.log(err);
    return { error: true };
  }
}

export async function actualizarVehiculo(obj) {
  try {
    let response = { error: true };
    const { code } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/vehiculo/actualizar-vehiculo",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
    }
    return response;
  } catch (err) {
    console.log("actualizarVehiculo err");
    console.log(err);
    return { error: true };
  }
}

export async function obtenerVehiculoPorPlaca(obj) {
  try {
    let response = null;
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/vehiculo/obtener-vehiculo-por-placa",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      if (Array.isArray(body) === true && body.length > 0) {
        response = body[0];
      }
    }
    return response;
  } catch (err) {
    console.log("obtenerVehiculoPorPlaca err");
    console.log(err);
    return null;
  }
}

export async function deshabilitarVehiculo(obj) {
  try {
    let response = { error: true };
    const { code } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/vehiculo/deshabilitar-vehiculo",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
    }
    return response;
  } catch (err) {
    console.log("deshabilitarVehiculo err");
    console.log(err);
    return { error: true };
  }
}

export async function habilitarVehiculo(obj) {
  try {
    let response = { error: true };
    const { code } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/vehiculo/habilitar-vehiculo",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
    }
    return response;
  } catch (err) {
    console.log("habilitarVehiculo err");
    console.log(err);
    return { error: true };
  }
}

export async function obtenerComboVehiculos() {
  try {
    let response = [];
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/vehiculo/obtener-combo-vehiculos",
      {
        headers: getHeaders(),
        method: POST,
        // body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS && Array.isArray(body) === true) {
      response = body;
    }
    return response;
  } catch (err) {
    console.log("obtenerInfoVehiculo err");
    console.log(err);
    return [];
  }
}

export async function vehiculoAsignado(obj) {
  try {
    let response = { error: true };
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/vehiculo/vehiculo-asignado",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      response.error = false;
      response.value = body;
    }
    return response;
  } catch (err) {
    console.log("obtenerInfoVehiculo err");
    console.log(err);
    return { error: true };
  }
}
